<template>
    <div class="container">
      <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
          <i class="el-icon-s-fold" ></i>
          <el-breadcrumb separator="/" >
            <el-breadcrumb-item >内容管理</el-breadcrumb-item>
            <el-breadcrumb-item class="bread" :to="{ path: '/manage/equipment/equipment-list' }">设备管理</el-breadcrumb-item>
            <el-breadcrumb-item >手术数据下载</el-breadcrumb-item>
          </el-breadcrumb>
      </div>
      <!-- 设备列表 -->
      <div class="table-content">
            <div class="header-common" >
              <div class="header-common-left">
                <div class="title">手术数据列表</div>
              </div>
              <div class="header-common-right">
                <el-button
                  class="right-button-out"
                  @click="exportTable"
                  type="text"
                  v-if="showActionDownload==true"
                  >
                  下载数据
                </el-button>
              </div>
            </div>
            <div class="table-list">
              <div class="condition">
                  <el-date-picker
                        id="s4"
                        v-model="value1"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="手术开始日期"
                        end-placeholder="手术结束日期"
                        ref="daterange"
                        style="background-color: #fff;"
                        popper-class="dateranges"
                        :picker-options="pickerOptions"
                        @change="handlechange">
                  </el-date-picker>
                  <input id="search_udi" v-model="search_udi" type="text" placeholder="UDI" class="el-input__inner" style="background-color: #fff;color: #333;width: 40%;" clearable>
                  <el-button
                    type="text"
                    size="medium"
                    class="action-button-search"
                    @click="searchContent()"
                    >
                    <i class="el-icon-search" size="medium"></i>
                  </el-button>
                  <!-- <el-button
                    type="text"
                    size="medium"
                    style="float: right;"
                    class="action-button"
                    @click="downloadBatchData"
                    v-if="multipleSelection.length>0"
                    >
                    批量下载
                  </el-button> -->
              </div>
              <el-table
                v-loading='loading'
                border
                :cell-style="tableCellStyle"
                :header-cell-style="tableHeaderCellStyle"
                :data="tableData"
                :max-height="tableHeight"
                tooltip-effect="dark"
                >
                <!-- @selection-change="handleSelectionChange" -->
                <!-- <el-table-column
                  type="selection"
                  width="55">
                </el-table-column> -->
                <el-table-column
                  type="index"
                  label="序号">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="人员姓名">
                </el-table-column>
                <el-table-column
                  prop="company"
                  label="公司名称">
                </el-table-column>
                <el-table-column
                  prop="submitDate"
                  label="提交日期"
                  >
                </el-table-column>
                <el-table-column
                  prop="operationDate"
                  label="手术日期">
                </el-table-column>
                <el-table-column
                  prop="hospital"
                  label="医院名称">
                </el-table-column>
                <el-table-column
                  prop="department"
                  label="科室名称">
                </el-table-column>
                <el-table-column
                  prop="age"
                  label="患者年龄">
                </el-table-column>
                <el-table-column
                  prop="gender"
                  label="患者性别">
                </el-table-column>
                <el-table-column
                  prop="part"
                  label="手术部位">
                </el-table-column>
                <el-table-column
                  prop="size"
                  label="肿瘤大小">
                </el-table-column>
                <el-table-column
                  prop="equipmentNumber"
                  label="设备编号">
                </el-table-column>
                <el-table-column
                  prop="needleNumber"
                  label="消融针编号">
                </el-table-column>
                <el-table-column
                  prop="needleQuantity"
                  label="消融针数量">
                </el-table-column>
                <el-table-column
                  prop="latitude"
                  label="纬度">
                </el-table-column>
                <el-table-column
                  prop="longitude"
                  label="经度">
                </el-table-column>
                <el-table-column
                  prop="remarks"
                  label="备注">
                </el-table-column>
                <!-- <el-table-column
                  label="操作"
                  style="display: flex;flex-direction: column;align-items: center;justify-content: center;"
                  >
                  <template slot-scope="scope">
                     <el-link :href="scope.row.url" style="color: #fff;" :underline="false">下载</el-link>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="PageSize"
              :total="totalAmount"
              :current-page="currentPage"
              @current-change="changeCurrentPage"
              @prev-click="prevClicvPage"
              @next-click="nextClickPage"
              style="margin-left: 15px;position:fixed;bottom:20px;">
            </el-pagination>
          </div>

    </div>
</template>

<script>
  import {permissionCheckUtil} from '../../../utils/permission.js'
  import {dataConversionUtil} from '../../../utils/excel.js'

  export default {
    data() {
      return {
        tableHeight:0,
        showActionDownload:false,

        totalAmount:1,//总数量
        totalPageAmount:1 ,//总页数
        PageSize:100,
        currentPage:1,

        tableData:[],
        multipleSelection:[],
        loading:false,

        //搜索条件
        search_start_date:'',
        search_end_date:'',
        search_udi:'',
        value1: '',
        pickerOptions: {
          disabledDate: this.disabledDate
        },

        resultCsv:[],
      }
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)

      this.sizeFun()

    },
    created() {
      this.search_udi = this.$route.query.udi

      this.judgePermissions()
    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    },
    methods:{
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },
      changeCurrentPage(page){
        this.currentPage = page
        this.searchContent()
      },
      prevClicvPage(page){
        this.currentPage = page
        this.searchContent()
      },
      nextClickPage(page){
        this.currentPage = page
        this.searchContent()
      },
      // 日期禁用
        disabledDate(time) {
          const date = new Date()
          return time.getTime() > date.getTime();
        },
        // 修改日期
        handlechange(val) {
          // val 返回格式为[Sun Jul 16 2023 00:00:00 GMT+0800 (中国标准时间), Fri Jul 21 2023 00:00:00 GMT+0800 (中国标准时间)]需转换年月日
          this.search_start_date = this.formatDateTime(val[0]);
          this.search_end_date = this.formatDateTime(val[1]);
          // this.timeAll = this.getAll(this.startTime, this.endTime); // 开始结束时间之间的每一天集合['2023-07-16', '2023-07-17', '2023-07-18']
        },
        // 中国标准时间 转换成 年月日
        formatDateTime (date) {
              var y = date.getFullYear();
              var m = date.getMonth() + 1;
              m = m < 10 ? ('0' + m) : m;
              var d = date.getDate();
              d = d < 10 ? ('0' + d) : d;
              var h = date.getHours();
              var minute = date.getMinutes();
              minute = minute < 10 ? ('0' + minute) : minute;
              return y + '-' + m + '-' + d;
         },
        // 获取开始结束时间之间的每一天
        getAll(start, end) {
             let dateList = [];
             var startTime = this.getDate(start);
             var endTime = this.getDate(end);
             while ((endTime.getTime() - startTime.getTime()) >= 0) {
                   var year = startTime.getFullYear();
                   var month = startTime.getMonth() + 1 < 10 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1;
                   var day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
                   dateList.push(year + "-" + month + "-" + day);
                   startTime.setDate(startTime.getDate() + 1);
             }
             return dateList;
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        judgePermissions(){
            let equipment5 = permissionCheckUtil.findName("equipment:download");
            if(equipment5==true){
              this.showActionDownload = true;
            }
        },
        // 搜索
        searchContent(){
          if(this.search_start_date.length<=0 || this.search_end_date.length<=0){
            this.$message({
              message:'请选择日期范围',
              type:'warning'
            })
            return
          }
          this.loading = true;
          const headers = {
              'Authorization': localStorage.getItem('token')
          }
          const url = '/download/equipment/search-surgery';

          const params = {
            "page":this.currentPage,
            'size':this.PageSize,
            'dateStart':this.search_start_date,
            'dateEnd':this.search_end_date,
            'udi':this.search_udi
          }

          this.$http({
            method:'GET',
            url:url,
            headers:headers,
            params:params
          }).then(res=>{
            this.loading = false;
            if(res.status == 200){//请求成功
            var obj = res.data;
              if(obj.code == 0){
                if(obj.data.surgeries){
                  this.tableData = obj.data.surgeries;
                  this.totalAmount = obj.data.totalAmount;
                  this.totalPageAmount = obj.data.pageAmount;
                }
              }else{
                this.$message.error(obj.message);
              }
            }else{
              this.$message.error(res.data.message);
            }
          }).catch(err=>{
            this.loading = false;
            if(!err.response){
              this.$message.error(err.message);
            }else{
              this.$message.error(err.response.data.message);
            }
          })
        },
        exportTable(){
          var tableHeader = [['序号','人员姓名','公司名称','提交日期','手术日期','医院名称','科室名称','患者年龄','患者性别','手术部位','肿瘤大小','设备编号','消融针编号','消融针数量','纬度','经度','备注']];

          var dataList = [];
          this.tableData.forEach((item,index)=>{
            dataList.push([
              index+1,
              item.name,
              item.company,
              item.submitDate,
              item.operationDate,
              item.hospital,
              item.department,
              item.age,
              item.gender,
              item.part,
              item.size,
              item.equipmentNumber,
              item.needleNumber,
              item.needleQuantity,
              item.latitude,
              item.longitude,
              item.remarks,
            ]);
          });

          if(dataList.length > 0){
            dataConversionUtil.dataToExcel('手术数据列表',tableHeader,dataList)
            this.$message.success('下载成功')
          }else{
            this.$message.warning('无手术数据下载')
          }

        },

        // downloadCSVData(url){
        //   this.$http({
        //     method:'get',
        //     url:url,
        //     baseURL:'',
        //     params:{},
        //     onDownloadProgress:(progressEvent)=>{

        //     }
        //   }).then(res=>{

        //     alert('111')

        //     alert(JSON.stringify(res))
        //     let a = document.createElement('a')
        //     a.style.display = none;
        //     a.href = res.data;
        //     a.setAttribute('download','test.csv')
        //     document.body.appendChild(a);
        //     a.click()
        //     // document.removeChild(a)
        //     // a.parentNode.removeChild(a);

        //     // setTimeout(()=>{
        //     //   a.remove()
        //     // },1000)

        //   }).catch(error=>{
        //     // alert(JSON.stringify(error))
        //   })
        // },
        sizeFun(){
          this.$nextTick(() => {
            this.tableHeight = window.innerHeight-300 < 300 ? 300 : window.innerHeight-300;
          })
        }
    },

  }
</script>


<style lang="scss" scoped>
.container {
  height: 100%;
  margin-top: $header-height;


  .bread >>>.el-breadcrumb__inner{
    color: #606266;
    font-weight: 400;
  }

  .action-button{
    width: 89px;
    height: 31px;
    background: #FAFAFA;
    border: 1px solid rgba(0,144,255,0.84);
    border-radius: 20px;
    background-color: #20478D;
    font-size: 14px;
    font-weight: 400;
    color: #00DEFF;
    // margin-right: 20px;
  }

  .equipment-distribution{
    margin: 0px 6px 20px 6px;
    display: flex;
    flex-direction: row;

    .handle-distribution{
      width: 100%;
      min-width: 740px;
      height: 310px;
      // border: 2px #1A3F81 solid;
      border-radius: 18px;
      padding-right: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;

      .handle-one{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .line-left{
          margin-right: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;

          p{
            color: #11FFF1;
            opacity: 0.2;
            font-size: 18;
            font-weight: 400;
          }

          span{
            color: #11FFF1;
            font-size: 18px;
            font-weight: 400;
          }
        }

        .line-middle{
          width: 162px;
          height: 162px;
          border-radius: 18px;
          // border: 2px solid rgba(0, 177, 183, 0.84);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .line-middle-rate{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);

            background: linear-gradient(0deg, #FF1800 0.1953125%, #D3CC15 99.6337890625%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(180deg, #D3CC15 0%, #FF1800 100%);

              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          .line-middle-rate-processing{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
            background: linear-gradient(0deg, #8033F2 0%, #00CCFF 99.6337890625%);            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(0deg, #8033F2 0%, #00CCFF 99.6337890625%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          .line-middle-rate-finish{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
            background: linear-gradient(0deg, #00FF54 0.1953125%, #15D3CC 99.6337890625%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(0deg, #00FF54 0.1953125%, #15D3CC 99.6337890625%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }



          .line-middle-status{
            font-size: 22px;

            font-weight: bold;
            color: #fff;
            text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
            background: linear-gradient(180deg, #FFFFFF 0%, #47D6FF 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin: 0;
          }
        }

        .line-right{
          margin-left: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;

          p{
            color: #11FFF1;
            opacity: 0.2;
            font-size: 18;
            font-weight: 400;
          }

          span{
            color: #11FFF1;
            font-size: 18px;
            font-weight: 400;
          }
        }
      }
    }

    .distribution-list{
      margin-top: 0;
      margin: 0px 6px 0px 6px;
      padding-bottom: 10px;
    }
  }

  .table-content{

    .header-common{
      height: 45px;
      border-radius: 12px 12px 0 0;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
      }
    }

    .table-list{
      .hander{
        // cursor: pointer;
        color: #fff;
        background-color: #104C90;
        border: 0px;
      }

      .action-button-waiting{
        float: left;
        width: 89px;
        height: 36px;
        background: #FAFAFA;
        border: 1px solid rgba(0,255,96,0.84);
        border-radius: 20px;
        background-color: #208D7F;
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
      }

      .action-button-search{
        width: 39px;
        margin-top:2px;
        // height: 40px;
        // background: #FAFAFA;
        // font-size: 14px;
        // font-weight: 400;
        color: #333;
        // margin-right: 20px;
        background-color:#fff;
        border-radius:0 50% 50% 0;
      }

      .action-button-process{
        float: left;
        width: 89px;
        height: 36px;
        background: #FAFAFA;
        border: 1px solid rgba(255, 132, 0, 0.84);
        border-radius: 20px;
        background-color: #B26100;
        font-size: 14px;
        font-weight: 400;
        color: #FFCC00;
      }

      .action-button-finish{
        float: right;
        width: 89px;
        height: 36px;
        background: #FAFAFA;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
      }
    }

  }

    .header-common{
      // width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      // margin: 0 6px;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;

        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }

      .header-common-right{

        .right-button{
          width: 89px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,255,96,0.84);
          border-radius: 20px;
          background-color: #208D7F;
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }

        .right-button-out{
          width: 89px;
          height: 40px;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
          margin-right: 20px;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/manage/equipment/equipment-data-download.vue